import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

import Loader from "../../component/Loader";
import Modal from "../../component/Modal";

import api from "../../../../services/api";

export default function List() {
  const [campaigns, setCampaigns] = useState();

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/githeo_campaign");
      setCampaigns(data);
    })();
  }, []);

  if (!campaigns) return <Loader />;

  return (
    <div className="space-y-6 py-6 px-8">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Campaigns</h1>
        <CreateCampaign />
      </div>
      <div className="border border-gray/10 rounded-2xl bg-white overflow-hidden">
        <div className="grid grid-cols-12 w-full text-titles-inactive text-xs font-bold bg-gray-light/30">
          <div className="px-4 py-3 col-span-2 font-semibold text-sm">Name</div>
          <div className="px-4 py-3 col-span-4 font-semibold text-sm">Github</div>
          <div className="px-4 py-3 col-span-2 font-semibold text-center text-sm">Fetching</div>
          <div className="px-4 py-3 col-span-1 font-semibold text-center text-sm">Users</div>
          <div className="px-4 py-3 col-span-3 font-semibold text-right text-sm">Created at</div>
        </div>
        <div className="bg-white">
          {campaigns.map((p) => (
            <Row key={p.id} data={p} />
          ))}
        </div>
      </div>
    </div>
  );
}

const Row = ({ data }) => {
  const navigate = useNavigate();
  const formatDate = (date) => {
    try {
      const dateObj = typeof date === "string" ? new Date(date) : date;

      if (isNaN(dateObj.getTime())) {
        return "Invalid date";
      }

      return format(dateObj, "dd/MM/yyyy - HH:mm");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid date";
    }
  };

  const getFetchStatusColor = (status) => {
    switch (status) {
      case "DONE":
        return "bg-green-100 text-green-800";
      case "TO_RUN":
        return "bg-yellow-100 text-yellow-800";
      case "RUNNING":
        return "bg-blue-100 text-blue-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div
      className="grid grid-cols-12 py-3 w-full text-gray-700 text-sm cursor-pointer border-b border-gray-100 transition-all duration-200 hover:bg-indigo-50 hover:shadow-sm"
      onClick={() => navigate(`/githeo/campaigns/${data._id}`)}>
      <div className="px-4 col-span-2 font-normal">{data.name}</div>
      <div className="px-4 col-span-4 truncate text-gray-600">{data.githubs}</div>
      <div className="px-4 col-span-2 flex justify-center">
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-normal ${getFetchStatusColor(data.fetchStatus)}`}>{data.fetchStatus}</span>
      </div>
      <div className="px-4 col-span-1 text-center font-normal">{data.usersCount}</div>
      <div className="px-4 text-right col-span-3 text-gray-500 italic">{data.createdAt ? formatDate(data.createdAt) : "N/A"}</div>
    </div>
  );
};

const CreateCampaign = ({}) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  const navigate = useNavigate();

  const handleForm = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post(`/githeo_campaign`, { name });
      if (!res.ok) throw res;
      toast.success("Created !");
      navigate(`/githeo/campaigns/${res.data._id}`);
      setOpen(false);
    } catch (e) {
      console.log("e", e);
      toast.error(e.code);
    }
  };

  if (!open)
    return (
      <button onClick={() => setOpen(true)} className="px-6 py-3.5 bg-indigo-500 hover:bg-indigo-400 transition-all duration-200 rounded-lg text-white font-semibold">
        Create new campaign
      </button>
    );

  return (
    <Modal title={"Create new Campaign"} isOpen={open} setIsOpen={() => setOpen(false)}>
      <form onSubmit={handleForm} className="w-full">
        <div className="space-y-4">
          <div>
            <input
              id="name"
              placeholder="Enter campaign name"
              className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none transition-all"
              value={name}
              required
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="flex justify-end pt-4">
            <button type="button" className="mr-3 px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-500" onClick={() => setOpen(false)}>
              Cancel
            </button>
            <button type="submit" className="px-5 py-2 bg-indigo-500 hover:bg-indigo-400 transition-all duration-200 text-white rounded-lg text-sm font-medium">
              Create Campaign
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};
